import React from "react";
import Desplegable from "../../desplegable";
import VistaInformatica from "../vistas/vista_informatica";
import FormInformatica from "../formularios/form_informatica";

const DesplegableTipoFormacion = (props) => {
    return (
        <Desplegable
            eventKey="3"
            id="3"
            handleButtonShow={props.handleButtonShow}
            showModal={props.state.showModalMatrix[3]}
            boton="Añadir"
            Toogle={"Informática"}
            Text={
                <VistaInformatica
                    DatosUsuario={props.state.DatosUsuario}
                    showModalInformaticaArray={props.state.showModalMatrix[4]}
                    handleButtonShow={props.handleButtonShow}
                    setInformatica={props.setInformatica}
                    putInformatica={props.putInformatica}
                    deleteInformatica={props.deleteInformatica}
                    setAlert={props.setAlert}
                    ErrorHandling={props.ErrorHandling}
                />
            }
            Form={
                <FormInformatica
                    DatosUsuario={props.state.DatosUsuario}
                    handleButtonShow={props.handleButtonShow}
                    setInformatica={props.setInformatica}
                    putInformatica={props.putInformatica}
                    setAlert={props.setAlert}
                    ErrorHandling={props.ErrorHandling}
                />
            }
            canEdit={true}
        />
    );
}

export default DesplegableTipoFormacion;